import { render, staticRenderFns } from "./BillingChangeHistory.vue?vue&type=template&id=5204d65e&scoped=true"
import script from "./BillingChangeHistory.vue?vue&type=script&lang=js"
export * from "./BillingChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./BillingChangeHistory.vue?vue&type=style&index=0&id=5204d65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204d65e",
  null
  
)

export default component.exports